// extracted by mini-css-extract-plugin
export default {"cont":"Menu_cont__1HKby","loader":"Menu_loader__i9q+l"};